export default "__VITE_PUBLIC_ASSET__ee58df63__"